import React from 'react';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import theme from 'theme';

function ProFeatureIcon({
  size = '0.9rem',
  marginRight = '0.3rem',
  color = theme.palette.primary.main,
}: {
  size?: string;
  marginRight?: string;
  color?: string;
}) {
  return (
    <DiamondOutlinedIcon
      sx={{
        fontSize: size,
        marginRight: marginRight,
        color: color,
      }}
    />
  );
}

export default ProFeatureIcon;
